import { Card, CardHeader, CardContent, Grid } from "@mui/material";

import Place from "@mui/icons-material/Place";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import ConfirmDialog from "./ConfirmDialog";

export default function SubscriptionCard(props) {
  //console.log("props: ", props);
  const subscription = props.subscription;
  const NOTHING_SELECTED = " - ";

  const [confirmDialog, setConfirmDialog] = React.useState({
    isOpen: false,
    title: "",
    id: "",
    subtitle: "",
  });

  function handleDelete() {
    setConfirmDialog({
      isOpen: true,
      id: subscription.id,
      title: "Ta bort bevakning",
      subtitle: "Det här kommer ta bort bevakningen.",
    });
  }
  //console.log("subscription: ", subscription);
  return (
    <>
      <Card style={{ marginTop: "30px" }}>
        <CardHeader
          action={
            <IconButton aria-label="settings" onClick={handleDelete}>
              <DeleteIcon />
            </IconButton>
          }
          title={
            subscription.category == NOTHING_SELECTED
              ? "Alla kategorier"
              : subscription.categoryName
          }
        />
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
          refreshFunc={props.getSubscriptionsByUser}
          whatToDelete="subscription"
          message="Din bevakning har tagits bort!"
        />
        <CardContent style={{ padding: "1vh" }}>
          <Grid container spacing={1}>
            <Grid item xs={9}>
              <span
                style={{
                  display: "flex",

                  color: "rgba(0,0,0,0.54)",
                }}
              >
                <Place />
                {subscription.county == NOTHING_SELECTED
                  ? "Alla Län"
                  : subscription.county}
                {" - "}
                {subscription.municipality == NOTHING_SELECTED
                  ? "Alla Kommuner "
                  : subscription.municipality}
              </span>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
